"use client";
import { createContext } from "react";
//#region src/checkbox/checkbox-checked-context.tsx
const CheckboxCheckedContext = createContext(false);
//#endregion
export { CheckboxCheckedContext };

//# sourceMappingURL=checkbox-checked-context.js.map